import { computed, toRef } from 'vue'
import { useProfile } from '@/composables/useProfile'
import useUserStore from '@/stores/user.store'
import useProfileStore from '@/stores/profile.store'
import useTranslate from '@/composables/useTranslate'

function useProfileDownload() {
  const userStore = useUserStore()
  const profileStore = useProfileStore()
  const profile = useProfile()

  const { translate } = useTranslate()

  const downloadLinks = toRef(profileStore, 'downloadLinks')
  const enableOptimization = toRef(profileStore, 'enableOptimization')
  const internal = toRef(userStore, 'isInternal')

  const enabled = computed(() => {
    const isValid = !!profile.value?.isValid
    const isInternal = internal.value
    return isValid || isInternal
  })

  const label = computed(() => translate(
    enabled.value
      ? 'pb2.downloadProfile.label'
      : 'pb2.downloadProfile.labelDisabled',
  ))

  return {
    enableOptimization,
    downloadLinks,
    label,
    enabled,
    internal,
  }
}

export default useProfileDownload
